import Konva from 'konva/konva'
import { timeToX } from '../utils'

const marginBottom = 15
export const separator = { color: 'Gray', width: 0.5, margin: 3 }
const background = { color: '#f8fbfe' }
const noData = { color: '#efefef' }
const futureRect = { padding: 1, color: '#f6f6f6' }

export default class VariableBase extends Konva.Group {
  _getInnerHeight () {
    return this._getValuesHeight() + 2 * separator.margin
  }

  get height () {
    return this._getInnerHeight() + marginBottom
  }

  get midHeight () {
    return this._getInnerHeight() / 2
  }

  _timeToX (time) {
    // convert time (X axis) value to canvas X coordinate
    // stretch to the width of variable values section
    // and offset with variable titles section width
    const { timeFrom, timeTo, width } = this
    return timeToX({ timeFrom, timeTo, width, time })
  }

  _addPoint (points, { time, value }) {
    points.push(this._timeToX(time))
    points.push(this._valueToY(value))
  }

  _calculateSeparatorsPoints () {
    const { width, yOffset } = this
    const top = yOffset
    const bottom = yOffset + this._getInnerHeight()
    return [
      [0, top, width, top], // top line
      [0, bottom, width, bottom] // bottom line
    ]
  }

  _renderSeparators () {
    this._calculateSeparatorsPoints()
      .map(points => new Konva.Line({
        points,
        stroke: separator.color,
        strokeWidth: separator.width,
        lineJoin: 'round'
      }))
      .forEach(line => {
        this.add(line)
      })
  }

  _renderBackground () {
    const { timeFrom, timeTo, yOffset } = this
    const x = this._timeToX(timeFrom)
    const width = this._timeToX(timeTo) - x
    const rect = new Konva.Rect({
      x,
      y: yOffset,
      width,
      height: this._getInnerHeight(),
      fill: background.color
    })

    this.add(rect)
  }

  _renderNoData () {
    const { values, timeFrom, timeTo, yOffset } = this
    const firstTime = (values && values[0] && values[0][0]) || timeTo

    if (firstTime > timeFrom) {
      const x = this._timeToX(timeFrom)
      const width = this._timeToX(firstTime) - x
      const rect = new Konva.Rect({
        x,
        y: yOffset,
        width,
        height: this._getInnerHeight(),
        fill: noData.color
      })

      this.add(rect)
    }
  }

  _renderFutureRect () {
    const { width, yOffset, nowX } = this

    if (width > nowX) {
      this.add(new Konva.Rect({
        x: nowX,
        y: yOffset + futureRect.padding,
        width: width - nowX,
        height: this._getInnerHeight() - 2 * futureRect.padding,
        fill: futureRect.color
      }))
    }
  }

  _addResizeHandle () {
    this.resizeHandleData.push({
      yOffsetBottom: this.yOffset + this._getInnerHeight(),
      minDiff: this._getMinValuesHeight() - this._getValuesHeight(),
      resizeHandler: this.resizeHeight.bind(this)
    })
  }

  _getValueAtTime (time) {
    const { values } = this
    let tuple = values.find((currentTuple, index) => {
      if (index < values.length - 1) {
        const nextTuple = values[index + 1]
        return nextTuple[0] > time
      }
    })
    if (tuple === undefined && values.length > 0) {
      tuple = values[values.length - 1]
    }
    if (tuple !== undefined) {
      return tuple[1]
    }
  }
}
